import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { store, history } from './store'
import { ThemeProvider } from './context/ThemeContext'
import ContainerFrameContainer from './components/containerFrameContainer'

// Persist last route (except login) for redirect after auth
history.listen((location) => {
  if (location.pathname !== '/login') {
    localStorage.setItem('lastRoute', location.pathname + location.search + location.hash)
  }
})

/**
 * Main application shell. Redux Provider + React Router v6 (HistoryRouter for custom history).
 */
export default class App extends Component {
  render () {
    console.log('NODE_ENV: ' + process.env.NODE_ENV)
    return (
      <Provider store={store}>
        <ThemeProvider>
          <HistoryRouter history={history}>
            <ContainerFrameContainer />
          </HistoryRouter>
        </ThemeProvider>
      </Provider>
    )
  }
}